import React from "react";
import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { updatePatient } from "actions/patient";
import { Tabs, Tab, TabList, TabPanel } from "react-tabs";
import PhysicianInformation from "./physician-information";

const PatientPhysicians = ({
  patientId,
  patientInfo,
  readOnly
}) => {

  return (
    <>
      <div className="patient-physician-container">
        <Tabs direction={"rtl"}>
          <TabList style={{ display: "flex", flexDirection: "row", flex: 1 }}>
            <h3
              style={{
                display: "flex",
                flex: 1,
                flexDirection: "row",
                fontSize: "1.4em",
                textTransform: "uppercase"
              }}
            >
              Physician
            </h3>
            {patientInfo.patient_product_lines?.map(x => (
              <Tab key={`physician-tab_${x.text}_${patientId}`}>{x.text}</Tab>
            ))}
          </TabList>
          {patientInfo.patient_product_lines?.map(x => (
            <TabPanel key={`physician-panel${x.text}_${patientId}`}>
              <PhysicianInformation
                physician={x.physician}
                readOnly={readOnly}
                patientId={patientId}
              />
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </>
  );
};

PatientPhysicians.propTypes = {
  patientInfo: PropTypes.object.isRequired,
  patientId: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired
};

export default PatientPhysicians;
